import React from 'react';
import { useTheme } from '../ThemeContext';
import Footer from './Footer';
import { PRODUCT_NAME, VIEWER_TERMS } from '../shared/homeHistoryReport';

export default function ReportViewerTerms() {
  const { colors } = useTheme();
  return (
    <main style={{
      minHeight: '100vh',
      background: colors.background,
      color: colors.text,
      display: 'flex',
      flexDirection: 'column',
      padding: '1.25rem 1.25rem 0',
      boxSizing: 'border-box',
      width: '100%',
    }}
    >
      <div style={{ maxWidth: '46rem', flex: '1 0 auto' }}>
        <h1 style={{ fontWeight: 400 }}>{PRODUCT_NAME}</h1>
        <h2 style={{ fontWeight: 650, fontSize: '1.2rem' }}>Report Viewer Terms</h2>
        <p style={{ lineHeight: 1.55 }}>{VIEWER_TERMS}</p>
        <p>
          <a href="mailto:support@pacarion.com">support@pacarion.com</a>
        </p>
      </div>
      <Footer />
    </main>
  );
}
